export default __webpack_public_path__ + "static/media/joaooliveira.997816bb.jpg";